import { useNavigate } from "react-router-dom";
import axios, { AxiosResponse } from "axios";
import { TOKEN_REFRESH_URL } from "@libs/apiUrl";
import { queryClient } from "@libs/reactQuery/queryClient";

class CustomError_Class extends Error {
  response?: {
    data: any;
    status: number;
    headers: string;
  };
}

const useAxios = () => {
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");

  const clearUser = () => {
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");

    localStorage.removeItem("isAutoLogin");
    localStorage.removeItem("order-storage");

    queryClient.setQueryData(["userInfo"], "");
    navigate("/");
  };

  const refreshAccessToken = async () => {
    try {
      const res = await axios.post(TOKEN_REFRESH_URL, null, {
        withCredentials: true,
      });

      if (res.status === 200) {
        console.log("토큰갱신");
        const newAccessToken = res.headers.authorization;
        localStorage.setItem("accessToken", newAccessToken);
        return newAccessToken;
      } else {
        clearUser();
        throw new Error("Failed to refresh token");
      }
    } catch (error) {
      clearUser();
      throw new Error("Error refreshing access token");
    }
  };

  const axiosInstance = axios.create({
    headers: { Authorization: `${accessToken}` },
    withCredentials: true,
  });

  axiosInstance.interceptors.request.use(
    async (req: any) => {
      if (!accessToken) return req;
      return req;
    },

    (error: unknown) => {
      if (error instanceof CustomError_Class) {
        console.log("error :", error);
      }
    },
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error) => {
      console.log(error);

      const originalRequest = error.config;
      const isAutoLogin = localStorage.getItem("isAutoLogin") === "true";

      if (
        error.response?.data?.data?.errorCode === "1002" &&
        !originalRequest._retry && isAutoLogin
      ) {
        originalRequest._retry = true;
        try {
          console.log("토큰 만료됨");
          const newToken = await refreshAccessToken();
          originalRequest.headers.Authorization = `${newToken}`;
          return axiosInstance(originalRequest);
        } catch (err) {
          clearUser();
          return Promise.reject(err);
        }
      }

      if (error.response?.data?.data?.errorCode === "1002" && !isAutoLogin) {
        clearUser();
      }
      
      return Promise.reject(error);
    },
  );

  return { axiosInstance };
};

export default useAxios;
